import React from 'react'
import { Radio } from '@arco-design/web-react'
import cx from 'classnames'
import styles from './index.module.less'

type Props = React.ComponentProps<typeof Radio.Group>

const RadioGroup = (props: Props) => {
  const { className, ...restProps } = props

  return <Radio.Group className={cx(styles.radioGroup, className)} {...restProps} />
}

export default RadioGroup
